export class RfqSessionNudgeSettingChannelType {
	public id: number;
	public name: string;

	constructor(rfqSessionNudgeSettingChannelType?: RfqSessionNudgeSettingChannelType) {
		Object.assign(this, rfqSessionNudgeSettingChannelType);
	}
}
